import type { User } from "@/lib/tanstack-query/users";
import type { AuthContinueType } from "@/lib/urls";
import type { Session } from "@supabase/supabase-js";
import { createContext } from "react";

export type VerifyOtpParams = {
  type: AuthContinueType;
  email?: string;
  token?: string;
  tokenHash?: string;
};

interface AuthContextType {
  user: User | null;
  session: Session | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  /** Roles are chosen in onboarding, not at signup. */
  signup: (
    email: string,
    password: string,
    name: string,
    redirectTo?: string,
  ) => Promise<void>;
  logout: () => Promise<void>;
  resetPassword: (email: string, redirectTo?: string) => Promise<void>;
  sendMagicLink: (email: string, redirectTo?: string) => Promise<void>;
  updatePassword: (password: string) => Promise<void>;
  verifyOtp: (params: VerifyOtpParams) => Promise<void>;
  /** @deprecated Prefer verifyOtp — kept for call-site compatibility during migrate */
  verifyResetPasswordToken: (email: string, token: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  session: null,
  isLoading: true,
  login: async () => {},
  signup: async () => {},
  logout: async () => {},
  resetPassword: async () => {},
  sendMagicLink: async () => {},
  updatePassword: async () => {},
  verifyOtp: async () => {},
  verifyResetPasswordToken: async () => {},
});
